/**
 * Reference imagery + one-line definitions for each style preference.
 * Used in Profile preferences picker.
 */
export const STYLE_GUIDE = {
  "Minimalist": {
    image: "https://images.unsplash.com/photo-1581338834647-b0fb40704e21?w=400",
    description: "Clean lines, monochrome palettes, exceptional fit. Less is more — every piece earns its place.",
  },
  "Casual": {
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400",
    description: "Relaxed everyday pieces: jeans, tees, sneakers. Comfort first, but always intentional.",
  },
  "Streetwear": {
    image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=400",
    description: "Hoodies, oversized fits, statement sneakers and graphic pieces drawn from skate and hip-hop culture.",
  },
  "Business Formal": {
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400",
    description: "Tailored suits, crisp shirts, polished leather. The boardroom uniform — sharp and undeniable.",
  },
  "Smart Casual": {
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400",
    description: "Blazer-and-jeans territory. Refined enough for dinner, easy enough for a Saturday.",
  },
  "Old Money": {
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400",
    description: "Heritage fabrics, quiet luxury, no visible logos. Polo shirts, loafers, cashmere knits.",
  },
  "Luxury": {
    image: "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=400",
    description: "Statement designer pieces, fine tailoring, premium materials. Made to be noticed.",
  },
  "Traditional/Ethnic": {
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400",
    description: "Cultural heritage wear — kurtas, sarees, sherwanis. Ceremonial and beautifully crafted.",
  },
  "Bohemian": {
    image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=400",
    description: "Free-spirited and eclectic: flowing fabrics, vintage prints, layered accessories.",
  },
  "Sporty": {
    image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=400",
    description: "Athleisure and performance pieces — sleek and ready to move.",
  },
  "Trendy": {
    image: "https://images.unsplash.com/photo-1485518882345-15568b007407?w=400",
    description: "Whatever the runways and feeds say right now — fast-moving, conversation-starting.",
  },
  "K-Fashion": {
    image: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=400",
    description: "Korean street style: oversized fits, layering, soft colour stories, statement accessories.",
  },
};

export const STYLES = Object.keys(STYLE_GUIDE);
